/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestHeartbeatMaxMissedSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_HEARTBEAT_MAX_MISSED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class AutoTestHeartbeatMaxMissedSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestHeartbeatMaxMissedSettingParser.decode(input).map(res => new AutoTestHeartbeatMaxMissedSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestHeartbeatMaxMissedSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestHeartbeatMaxMissedSettingParser.encode(data);
    }
    static schema() {
        return AutoTestHeartbeatMaxMissedSettingParser.schema();
    }
}
